import { FC, memo } from 'react';

import { LegView } from '@mopla/data-models';
import { getItineraryTimingV2 } from '@mopla/utils';

import { TripSchemeLayout } from './TripSchemeLayout';

interface ITripSchemeProps {
	className?: string;
	bookingItineraryLegs: Array<LegView>;
	hasShortView?: boolean;
	testId?: string;
}

export const TripScheme: FC<ITripSchemeProps> = memo(
	({
		className,
		bookingItineraryLegs,
		hasShortView,
		testId = 'TripScheme',
	}) => {
		if (hasShortView) {
			return (
				<TripSchemeLayout
					className={className}
					testId={testId}
					preparedItineraryTimingSegments={[
						getItineraryTimingV2(bookingItineraryLegs),
					]}
				/>
			);
		}

		return (
			<TripSchemeLayout
				className={className}
				testId={testId}
				preparedItineraryTimingSegments={bookingItineraryLegs.map((leg) =>
					getItineraryTimingV2(leg)
				)}
			/>
		);
	}
);
